/* Do NOT modify this file  - Automatically generated */

window.algoliaShopify = {};
algoliaShopify.config = {
  "app_id":"K4GLX02XDN",
  "search_api_key":"8990032a777c331ea8907b1e4fe6f034",
  "index_prefix":"ntb_en_",
  "index_products":true,
  "index_collections":true,
  "index_articles":false,
  "index_pages":false,
  "sort_orders":[
    {"key":"title","title":"Name","asc":{"active":true,"title":"Art.Nr. (grouped)"}},
    {"key":"published_at","title":"Publication date","desc":{"active":true,"title":"Newest"}},
    {"key":"recently_ordered_count","title":"Popularity","desc":{"active":true,"title":"Most popular"}},
    {"key":"title","title":"Name","desc":{"active":false,"title":"Name Z-A"}},
    {"key":"price","title":"Price","asc":{"active":false,"title":"Cheapest first"}},
    {"key":"price","title":"Price","desc":{"active":false,"title":"Most expensive first"}},
    {"key":"price_ratio","title":"Price ratio","asc":{"active":false,"title":"Highest discount first"}},
    {"key":"published_at","title":"Publication date","asc":{"active":false,"title":"Oldest first"}},
    {"key":"vendor","title":"Vendor","asc":{"active":false,"title":"Vendor"}},
    {"key":"vendor","title":"Vendor","desc":{"active":false,"title":"Vendor Z-A"}},
    {"key":"inventory_quantity","title":"Inventory quantity","desc":{"active":false,"title":"Most available"}},
    {"key":"grams","title":"Weight","asc":{"active":false,"title":"Lightest first"}},
    {"key":"grams","title":"Weight","desc":{"active":false,"title":"Heaviest first"}}],
  "facets":[
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.en__Collection",
     "title":"Collection",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.de__Collection",
     "title":"Kollektion",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.fr__Collection",
     "title":"Collection",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.nl__Collection",
     "title":"Collectie",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.es__Collection",
     "title":"Colección",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.en__Category",
     "title":"Category",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.de__Category",
     "title":"Kategorie",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.fr__Category",
     "title":"Catégorie",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.nl__Category",
     "title":"Categorie",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.es__Category",
     "title":"Categoría",
     "type":"conjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.Swatch",
     "title":"Swatch",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.en__Color name",
     "title":"Color Name",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.de__Color name",
     "title":"Farbname",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.fr__Color name",
     "title":"Nom de la couleur",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.nl__Color name",
     "title":"Kleurnaam",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.es__Color name",
     "title":"Nombre de color",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"grams",
     "title":"Weight",
     "type":"slider"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.en__Quality name",
     "title":"Quality Name",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.de__Quality name",
     "title":"Qualitätsname",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.fr__Quality name",
     "title":"Nom de qualité",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.nl__Quality name",
     "title":"Kwaliteitsnaam",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.es__Quality name",
     "title":"Nombre de calidad",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.Composition",
     "title":"Composition",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
       "enabled":true,
       "forgettable":true,
       "name":"named_tags.en__Motifs",
       "title":"Motifs",
       "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
       "enabled":true,
       "forgettable":true,
       "name":"named_tags.de__Motifs",
       "title":"Motive",
       "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
       "enabled":true,
       "forgettable":true,
       "name":"named_tags.fr__Motifs",
       "title":"Motifs",
       "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
       "enabled":true,
       "forgettable":true,
       "name":"named_tags.nl__Motifs",
       "title":"Motieven",
       "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
       "enabled":true,
       "forgettable":true,
       "name":"named_tags.es__Motifs",
       "title":"Diseño",
       "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.en__Subapplications",
     "title":"Applications",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.de__Subapplications",
     "title":"Anwendungen",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.fr__Subapplications",
     "title":"Applications",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.nl__Subapplications",
     "title":"Toepassingen",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.es__Subapplications",
     "title":"Aplicaciones",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.en__Finishing",
     "title":"Finishing",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.de__Finishing",
     "title":"Finish",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.fr__Finishing",
     "title":"Finition",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.nl__Finishing",
     "title":"Afwerkingen",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.es__Finishing",
     "title":"Acabado",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.en__Surface",
     "title":"Surface",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.de__Surface",
     "title":"Oberfläche",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.fr__Surface",
     "title":"Surface",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.nl__Surface",
     "title":"Oppervlakte",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.es__Surface",
     "title":"Superficie",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.Certificates",
     "title":"Certificates",
     "type":"disjunctive"
    },
    {"available_types":["conjunctive","disjunctive","slider"],
     "enabled":true,
     "forgettable":true,
     "name":"named_tags.Stretch",
     "title":"Stretch",
     "type":"disjunctive"
    },
    {"available_types":["menu","conjunctive","disjunctive"],
     "enabled":false,
     "name":"product_type",
     "title":"Type",
     "type":"conjunctive"
    },
    {"available_types":["menu","conjunctive","disjunctive"],
     "enabled":false,
     "name":"vendor",
     "title":"Vendor",
     "type":"conjunctive"
    },
    {"available_types":["menu","conjunctive","disjunctive"],
     "enabled":false,
     "name":"tags",
     "title":"Tags",
     "type":"conjunctive"
    },
    {"available_types":["disjunctive"],
     "enabled":false,
     "name":"price_range",
     "title":"Price range",
     "type":"disjunctive"
    },
    {"available_types":["slider"],
     "enabled":false,
     "name":"price",
     "title":"Price",
     "type":"slider"}],
  "powered_by":false,
  "colors":{"main":"#003c22","secondary":"#888","highlight":"#41A66D"},
  "autocomplete_enabled":true,
  "autocomplete_debug":false,
  "input_selector":".algo-search-form input[type=\"text\"], .algo-search-form input[type=\"search\"]",
  "products_autocomplete_hits_per_page":10,
  "collections_autocomplete_hits_per_page":4,
  "articles_autocomplete_hits_per_page":2,
  "pages_autocomplete_hits_per_page":2,
  "instant_search_enabled":true,
  "instant_search_enabled_on_collection":true,
  "results_selector":".algolia-shopify-instantsearch",
  "products_full_results_hits_per_page":40,
  "collections_full_results_hits_per_page":10,
  "show_products":true,
  "analytics_enabled":true,
  "collection_id_indexing":false,
  "collection_id_query_rules":false,
  "collection_search_feature_enabled":false,
  "collection_css_selector":".algolia-shopify-instantsearch",
  "collection_facets":null,
  "collection_sort_orders":null};
